import React from 'react'
import { Sidebar } from '../shared/sidebar/Sidebar'
import { Header } from '../shared/header/Header'
import { Footer } from '../shared/footer/Footer'
import Switch from 'react-bootstrap/esm/Switch'
import { Home } from './home/Home'
import { LopBanDo } from './lopbando/LopBanDo'
import { ChucNang } from './hethong/chucnang/ChucNang'
import { NhomQuyen } from './hethong/nhomquyen/NhomQuyen'
import { TaiKhoan } from './hethong/taikhoan/TaiKhoan'
import { HienTrangSuDungDatLua } from './hientrangsudungdatlua/HienTrangSuDungDatLua'
import { DiemLayMau } from './diemlaymau/DiemLayMau'
import { PhanQuyen } from './hethong/phanquyen/PhanQuyen'
import { LopMau } from './lopmau/LopMau'
import { LienHe } from './tienich/lienhe/LienHe'
import { Trang } from './tienich/trang/Trang'
import { DonViDatDai } from './donvidatdai/DonViDatDai'
import { Slide } from './tienich/slide/Slide'
import { Route } from 'react-router-dom'
import { PostCategory } from './tienich/postcategory'
import { BaoCaoChatLuongDat } from './baocaochatluongdat/BaoCaoChatLuongDat'
import { Post } from './tienich/post'
import { BanDoThoNhuong } from './bandothonhuong/BanDoThoNhuong'
import { BanDoMucDoThichHop } from './bandomucdothichhop/BanDoMucDoThichHop'
import { BanDoDeXuatSuDungDat } from './bandodexuatsudungdat/BanDoDeXuatSuDungDat'
import { BanDoChatLuongDat } from './bandochatluongdat/BanDoChatLuongDat'
import { BanDoNen } from './bandonen/BanDoNen'
import { LoaiCay } from './danhmuc/loaicay/LoaiCay'
import { BanDoDeXuatPhanBon } from './bandodexuatphanbon/BanDoDeXuatPhanBon'
import { NhatKyDangNhap } from './hethong/nhatkydangnhap/nhatkydangnhap'
import { SoLieuChatLuongDat } from './baocaochatluongdat/SoLieuChatLuongDat'
import { LienKetWebsite } from './tienich/lienketwebsite/LienKetWebSite'
import { BanDo } from './bando/BanDo'
import { HuongDan } from './tienich/huongdan/huongdan'
import { HuongDanAddEdit } from './tienich/huongdan/huongdanaddedit'
import { GopY } from './tienich/gopy/GopY'

export const Main = (props) => {
    return (
        <div id="wrapper">
            <Sidebar></Sidebar>
            <div id="content-wrapper">
                <div id="content">
                    <Header></Header>
                    <div className="container-fluid">
                        {/* {props.children} */}
                        <Switch>
                            <Route path='/' component={Home} exact />
                            <Route path='/main/home' component={Home} />
                            <Route path='/main/lopbando' component={LopBanDo} />
                            <Route path='/main/hethong/chucnang' component={ChucNang} />
                            <Route path='/main/hethong/nhomquyen' component={NhomQuyen} />
                            <Route path='/main/hethong/taikhoan' component={TaiKhoan} />
                            <Route path='/main/hientrangsudungdatlua' component={HienTrangSuDungDatLua} />
                            <Route path='/main/bando' component={BanDo} />
                            <Route path='/main/bandothonhuong' component={BanDoThoNhuong} />
                            <Route path='/main/bandomucdothichhop' component={BanDoMucDoThichHop} />
                            <Route path='/main/bandodexuatsudungdat' component={BanDoDeXuatSuDungDat} />
                            <Route path='/main/bandochatluongdat' component={BanDoChatLuongDat} />
                            <Route path='/main/diemlaymau' component={DiemLayMau} />
                            <Route path='/main/hethong/phanquyen' component={PhanQuyen} />
                            <Route path='/main/tienich/post' component={Post} />
                            <Route path='/main/tienich/postcategory' component={PostCategory} />
                            <Route path='/main/lopmau' component={LopMau} />
                            <Route path='/main/tienich/lienhe' component={LienHe} />
                            <Route path='/main/tienich/lienketwebsite' component={LienKetWebsite} />
                            <Route path='/main/tienich/trang' component={Trang} />
                            <Route path='/main/tienich/huongdan' component={HuongDan} />
                            <Route path='/main/tienich/huongdanaddedit/:id' component={HuongDanAddEdit} />
                            <Route path='/main/donvidatdai' component={DonViDatDai} />
                            <Route path='/main/tienich/slide' component={Slide} />
                            <Route path='/main/tienich/gopy' component={GopY} />
                            <Route path='/main/baocaochatluongdat' component={BaoCaoChatLuongDat}/>
                            <Route path='/main/solieu' component={SoLieuChatLuongDat}/>
                            <Route path='/main/bandonen' component={BanDoNen}/>
                            <Route path='/main/danhmuc/loaicay' component={LoaiCay}/>
                            <Route path='/main/bandodexuatphanbon' component={BanDoDeXuatPhanBon}/>
                            <Route path='/main/hethong/nhatkydangnhap' component={NhatKyDangNhap} />
                        </Switch>
                    </div>
                </div>
                <Footer></Footer>
            </div>
        </div>
    )
}
